import React, { Component } from 'react';

import { BrowserRouter as Router, Route} from "react-router-dom";
import './App.css';
import 'tachyons';



import Supervisor from './Supervisor';
import AdHocCollecting from './AdHocCollecting';

class App extends Component {
constructor(props){
  super(props);

  this.state ={
    isLogedIn:false,

  }

}

Login = (val) =>{
  this.setState({isLogedIn:val});
}



  render() {
    return (
        <Router>
        <div>


      <Route path="/" exact component={Supervisor} />

      <Route path="/collecting/:link" component={AdHocCollecting} />



          </div>
        </Router>








    );
  }
}

export default App;


//Login -> done

//Logout

//add assistant

//Reports ( daily report, child detail, export data )

//Data uploads (
//upload list , add collector, add child , add class,
// select child -> change child => create barcodes
// select class -> change class => create barcodes
// select collector -> change collector => create barcodes
//)



// WEBPACK FOOTER //
// ./src/App.js